// Corresponds to Windows PlatformDataCollectionLevel: https://docs.microsoft.com/en-us/uwp/api/windows.system.profile.platformdatacollectionlevel
// When the Windows setting is at or above the event security level we log the event.
// These classifications are ignored outside UWP.
// Currently we classify all logs as either Security or Enhanced.
// Enhanced should be applied to all events that contain information generated from Windows operations.
// Security should be applied to events containing only information sourced from the web (Windows diagnostic settings do not apply to web apps).
// NOTE: Currently Security is the default for all logs inside the app (meaning they will always be logged). Ensure any sensitive data is explicitly classified.
export var DataSecurityLevel;
(function (DataSecurityLevel) {
    DataSecurityLevel[DataSecurityLevel["Security"] = 0] = "Security";
    DataSecurityLevel[DataSecurityLevel["Basic"] = 1] = "Basic";
    DataSecurityLevel[DataSecurityLevel["Enhanced"] = 2] = "Enhanced";
    DataSecurityLevel[DataSecurityLevel["Full"] = 3] = "Full";
})(DataSecurityLevel || (DataSecurityLevel = {}));
//# sourceMappingURL=DataSecurityLevel.js.map